import fetchClient from './fetch-client'

const baseUrl = '/auth'

function custom(url, body = {}, options = {}) {
  return fetchClient(`${baseUrl}${url}`, { body, ...options })
}

export { custom }
